import { useState, useEffect } from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonBadge from "components/ArgonBadge";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import axios, { baseURL } from "utils/api";

const columns3 = [
  { name: "sno", align: "center" },
  { name: "type", align: "left" },
  { name: "Organization", align: "left" },
  { name: "Position", align: "center" },
  { name: "Start Date", align: "center" },
  { name: "End Date", align: "center" },
  // { name: "Duration", align: "center" },
  // { name: "Currently working status", align: "center" },
  { name: "Classes", align: "center" },
  { name: "Board", align: "center" },
  { name: "Subjects", align: "center" },
  { name: "About", align: "center" },
  // { name: "action", align: "center" },
];

const TeachingExperienceTableData = (id, refresh) => {
  const [rows3, setRows] = useState([]);

  useEffect(() => {
    if (!id) return;

    axios
      .get(`${baseURL}/tutor?id=${id}`)
      .then((res) => {
        console.log("Tutor Details API Response:", res.data);
        const tutor = res.data.data;
        const experiences = tutor.professionalExperience || [];
        console.log("Professional Experience:", experiences);

        const formattedRows = experiences.map((exp, index) => ({
          sno: (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {index + 1}
            </ArgonTypography>
          ),
          type: (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {exp.experienceType || "N/A"}
            </ArgonTypography>
          ),
          Organization: (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {exp.organization || "N/A"}
            </ArgonTypography>
          ),
          Position: (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {exp.position || "N/A"}
            </ArgonTypography>
          ),

          "Start Date": (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {exp.startDate
                ? new Date(exp.startDate).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })
                : "N/A"}
            </ArgonTypography>
          ),
          "End Date": (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {exp.endDate
                ? new Date(exp.endDate).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })
                : "Present"}
            </ArgonTypography>
          ),
          Classes: (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {exp?.classes && Array.isArray(exp.classes) && exp.classes.length > 0
                ? exp.classes.map((cls) => cls?.name || cls).join(", ")
                : "N/A"}
            </ArgonTypography>
          ),
          Board: (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {exp?.boards && Array.isArray(exp.boards) && exp.boards.length > 0
                ? exp.boards.map((board) => board?.name || board).join(", ")
                : "N/A"}
            </ArgonTypography>
          ),
          Subjects: (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {exp?.subjects && Array.isArray(exp.subjects) && exp.subjects.length > 0
                ? exp.subjects.map((subject) => subject?.name || subject).join(", ")
                : "N/A"}
            </ArgonTypography>
          ),
          About: (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {exp.description || "N/A"}
            </ArgonTypography>
          ),
          // action: (
          //   <ArgonBox display="flex" alignItems="center" gap={0}>
          //     {/* View Profile */}
          //     <Button
          //       variant="text"
          //       size="large"
          //       component={Link}
          //       to={`/tutors/profile/${id}`}
          //       sx={{ minWidth: "12px", p: 0 }}
          //     >
          //       <VisibilityIcon color="primary" />
          //     </Button>

          //     {/* Delete */}
          //     <Button
          //       variant="text"
          //       size="large"
          //       sx={{ minWidth: "32px", p: 0 }}
          //       onClick={() => handleDeleteClick(exp._id)}
          //     >
          //       <DeleteIcon color="error" />
          //     </Button>
          //   </ArgonBox>
          // ),
        }));

        setRows(formattedRows);
      })
      .catch((err) => {
        console.error("❌ Error fetching tutor teaching experience:", err);
      });
  }, [id, refresh]);

  return { columns3, rows3 };
};

export default TeachingExperienceTableData;

// /* eslint-disable react/prop-types */
// // Argon Dashboard 2 MUI components
// import ArgonBox from "components/ArgonBox";
// import ArgonTypography from "components/ArgonTypography";
// import ArgonAvatar from "components/ArgonAvatar";
// import ArgonBadge from "components/ArgonBadge";
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import DeleteIcon from '@mui/icons-material/Delete';

// // Images
// import team2 from "assets/images/team-2.jpg";
// import team3 from "assets/images/team-3.jpg";
// import team4 from "assets/images/team-4.jpg";
// import { Button } from "@mui/material";
// import { Link } from "react-router-dom";

// const TeachingPreferenceTableData =  (id,handleDeleteClick)=>({
//   columns: [

//     {name:"sno",align:"center"},
//     {name:"type",align:"left"},
//     {name:"Company Name", align:"left"},
//     {name:"Designation",align:"center"},
//     {name:"Start Year",align:"center"},
//     {name:"End Year",align:"center"},
//     {name:"Duration",align:"center"},
//     {name:"Currently working status",align:"center"},
//     {name:"Classes",align:"center"},
//     {name:"Board",align:"center"},
//     {name:"Subjects",align:"center"},
//     {name:"About",align:"center"},
//     ],

//   rows: [
//     {
//       sno:<ArgonTypography variant="caption" fontWeight="medium" color="text">{1}</ArgonTypography>,
//       "type":<ArgonTypography variant="caption" fontWeight="medium" color="text">{"School"}</ArgonTypography>,
//       "Company Name": <ArgonTypography variant="caption" fontWeight="medium" color="text">{"Delhi Public School"}</ArgonTypography>,
//       "Designation": <ArgonTypography variant="caption" fontWeight="medium" color="text">{"Senior Teacher"}</ArgonTypography>,
//       "Start Year": <ArgonTypography variant="caption" fontWeight="medium" color="text">{"2020"}</ArgonTypography>,
//       "End Year": <ArgonTypography variant="caption" fontWeight="medium" color="text">{"2023"}</ArgonTypography>,
//       "Duration": <ArgonTypography variant="caption" fontWeight="medium" color="text">{"3 years"}</ArgonTypography>,
//       "Currently working status": <ArgonTypography variant="caption" fontWeight="medium" color="text">{"No"}</ArgonTypography>,
//       "Classes": <ArgonTypography variant="caption" fontWeight="medium" color="text">{"Class 9-12"}</ArgonTypography>,
//       "Board": <ArgonTypography variant="caption" fontWeight="medium" color="text">{"CBSE"}</ArgonTypography>,
//       "Subjects": <ArgonTypography variant="caption" fontWeight="medium" color="text">{"Physics, Mathematics"}</ArgonTypography>,
//       "About": <ArgonTypography variant="caption" fontWeight="medium" color="text">{"	Experienced teacher with a passion for helping students excel in STEM subjects."}</ArgonTypography>,
//        action: (
//        <ArgonBox display="flex" alignItems="center" gap={0}>
//            {/* View Icon */}
//             <Button variant="text"  size="large" component={Link} to="/tutors/profile" sx={{minWidth:"12px",p:0}} >
//               <VisibilityIcon color="primary"/>
//             </Button>
//             {/* Delete icon */}
//            <Button variant="text"  size="large" sx={{minWidth:"32px",p:0}}
//            onClick={() =>handleDeleteClick()} >
//              <DeleteIcon color="error"/>
//            </Button>

//          </ArgonBox>
//        ),
//     },

//   ],
// });

// export default TeachingPreferenceTableData;
